import { FunctionComponent } from 'react';

import { ValidationItems, Widget } from '@kanda-libs/ks-component-ts';

import {
  ADDRESS_FIELD_MANUAL_PROPS,
  AddressManualFieldNames,
} from './constants';
import useManualFieldWidget from './useManualFieldWidget';

interface AddressFieldsWidgetsManualFieldProps {
  name: AddressManualFieldNames;
  validation?: ValidationItems;
  onBlur?: () => void;
}

const AddressFieldsWidgetsManualField: React.FunctionComponent<AddressFieldsWidgetsManualFieldProps> =
  function ({ name, ...rest }) {
    const { widgetName, label } = useManualFieldWidget(name);
    // eslint-disable-next-line
    const Tag = Widget[widgetName] as FunctionComponent<any>;
    const props = ADDRESS_FIELD_MANUAL_PROPS[name];

    if (!Tag) return null;
    return <Tag label={label} {...props} {...rest} />;
  };

export default AddressFieldsWidgetsManualField;
